import React from "react";
import {
  RiCircleLine,
  RiAlertFill,
  RiAlarmWarningFill,
  RiInformationFill,
  RiCloseCircleLine,
} from "react-icons/ri";

const classNamesFill = {
  success: "bg-success border-success text-white",
  danger: "bg-danger border-danger text-white",
  warning: "bg-warning border-warning text-black",
  info: "bg-info border-info text-white",
};

const classNamesOutline = {
  success: "bg-white border-success text-black",
  danger: "bg-white border-danger text-black",
  warning: "bg-white border-warning text-black",
  info: "bg-white border-info text-black",
};

const classNamesIconOutline = {
  success: "text-success",
  danger: "text-danger",
  warning: "text-warning",
  info: "text-info",
};

const ToastComponent = (props) => {
  // variant : success, danger, warning or info
  const { id, message, isDismissible, isOutlined, variant, onClose } = props;

  const VariantClassName = () => {
    return (isOutlined ? classNamesOutline : classNamesFill)[variant];
  };

  const Icon = () => {
    const className = isOutlined && classNamesIconOutline[variant];
    switch (variant) {
      case "success":
        return <RiCircleLine className={className} />;
      case "danger":
        return <RiAlertFill className={className} />;
      case "warning":
        return <RiAlarmWarningFill className={className} />;
      default:
        return <RiInformationFill className={className} />;
    }
  };

  return (
    <div className={`app-toast-component border ${VariantClassName()}`}>
      <Icon />
      <span>{message}</span>
      {isDismissible && (
        <RiCloseCircleLine
          className="app-toast-component-close"
          onClick={() => onClose && onClose(id)}
        />
      )}
    </div>
  );
};

export default ToastComponent;
